import React from 'react';
import { CloseButton } from '@cb/apricot-react';
import Input from '../../../../ui/form/Input';
import { Room, RoomWId } from '../types';

interface AddRoomRowProps {
  handleDelete: (room: Room) => void;
  editRoomHandler: (room: RoomWId) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  formError: { title: string; capacity: string };
  // eslint-disable-next-line
  roomRow: any;
  UI_PREFIX: string;
  deleteEnabled: boolean;
}

export default function AddRoomRow({
  handleDelete,
  editRoomHandler,
  formError,
  roomRow,
  UI_PREFIX,
  deleteEnabled,
}: AddRoomRowProps) {
  //roomId is temp populated in the FE
  const index = roomRow.id;
  return (
    <tr key={index}>
      <td
        style={{
          verticalAlign: 'middle',
          textAlign: 'center',
        }}
      >
        <CloseButton
          id={`${UI_PREFIX}-delete-row-${index}`}
          icon='trash'
          disabled={!deleteEnabled} //{localState.form.length <= 1}
          onClick={() => handleDelete(roomRow)}
          iconDecorative
          greyscale={!deleteEnabled} //{localState.form.length <= 1}
          type='button'
          aria-label={`Delete row ${index}`}
        />
      </td>
      <td
        style={{
          width: '50%',
          verticalAlign: 'middle',
        }}
      >
        <Input
          errorMessage={formError ? formError.title : ''}
          id={`${UI_PREFIX}-title-${index}`}
          label='Room Name'
          labelClassName='cb-sr-only'
          maxLength={254}
          name={`${UI_PREFIX}-title-${index}`}
          onChange={(e) => {
            editRoomHandler(roomRow.id)(e);
          }}
          required={true}
          value={roomRow.title ? roomRow.title : ''}
          ariaLabel={`Enter the name of the room ${index}`}
        />
      </td>
      <td
        style={{
          width: '40%',
          verticalAlign: 'middle',
        }}
      >
        <Input
          errorMessage={formError ? formError.capacity : ''}
          id={`${UI_PREFIX}-capacity-${index}`}
          label='Capacity'
          labelClassName='cb-sr-only'
          maxLength={4}
          name={`${UI_PREFIX}-capacity-${index}`}
          onChange={(e) => {
            editRoomHandler(roomRow.id)(e);
          }}
          required={true}
          value={roomRow.capacity ? roomRow.capacity.toString() : ''}
          ariaLabel={`Enter the capacity of the room ${index}`}
        />
      </td>
    </tr>
  );
}
